import React, {useEffect, useState} from 'react';
import api from "../services/api";
import {Table} from "reactstrap";
import Time from "../components/Time";

const PurchaseHistory = () => {
    const [coverages, setCoverages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.fetchRecentCoverages().then(response => {
            setCoverages(response.data.data);

            setLoading(false);
        });
    }, []);

    return (
        <div className="page">
            <h1 className="page-header">Purchase History</h1>

            {!loading &&
            <React.Fragment>
                {!coverages.length ?
                    <p className="mb-0 text-muted">No recent coverages</p> :
                    <Table bordered striped responsive>
                        <thead>
                        <tr>
                            <th className="compact">Purchase Date</th>
                            <th className="compact">Plan Category</th>
                            <th className="compact">Plan</th>
                            <th className="compact">Payment</th>
                        </tr>
                        </thead>
                        <tbody>
                        {coverages.map(coverage => {
                            return (
                                <tr key={coverage.id}>
                                    <td className="compact">
                                        <Time time={coverage.transaction.created_at}/>
                                    </td>
                                    <td>{coverage.plan_category}</td>
                                    <td className="compact">
                                        {coverage.plan_name} <br/>
                                        ${coverage.plan_premium_adjusted}
                                    </td>
                                    <td className="compact">
                                        {coverage.transaction.status_name}
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>}
            </React.Fragment>}
        </div>
    );
};

export default PurchaseHistory;
